<template>
<div class="grid grid-cols-2 grid-flow-col gap-2">
    <div class="">
        <h5 class="text-white text-xs mb-5">Thickness</h5>
        <div class="flex">
            <div class="range-slider-wrapper">
                <input type="range" min="1" class="w-full" @change="updateThickness" max="100"
            :value="form.coordinates_data.thickness" />
            </div>
            <span class="text-white ml-3 text-lg">{{ this.form.coordinates_data.thickness }}</span>
        </div>

        <h5 class="text-white text-xs mb-2">Color</h5>
        <div class="color-wrapper">
            <div class="input-color-container">
                <input id="coordinates_data_color" type="color" v-model="form.coordinates_data.color">
            </div>
            <label for="coordinates_data_color">{{ form.coordinates_data.color }}</label>
        </div>

    </div>
    <div class="border-gray-800 border-l-2 pl-2">
        <h5 class="text-white text-xs">GPX</h5>

        <GPXUploadBox
        :form="form"
        :changeUploadBoxState="changeUploadBoxState"
        :errors="errors"
        />

    </div>
</div>
</template>

<script>
import GPXUploadBox from './GPXUploadBox';

export default {
    components: {
        GPXUploadBox
    },
    props: ['form', 'changeUploadBoxState', 'errors'],
    methods:{
        updateThickness(e){
            this.form.coordinates_data.thickness = parseInt(e.target.value);
        }
    }
}
</script>
